import React from "react";
import { Button, Result } from "antd";
import { logout } from "@utils/logout";

function YourLoggedIn(props) {
  const userRole = localStorage.getItem("role");
  return (
    <Result
      title="شما در حال حاضر وارد شده اید."
      extra={
        <>
          <Button key="logout" type="secondary" onClick={logout}>
            خروج
          </Button>
          <Button
            type="primary"
            key="dashboard"
            href={userRole === "ADMIN" ? "admin-dashboard" : "dashboard"}
          >
            پنل مدیریت
          </Button>
        </>
      }
    />
  );
}

export default YourLoggedIn;
